import { checkSecurityDomain } from '../../../utils/auth';
import { redirectPreservation } from '../../../utils/redirectPreservation';
import { urlSync } from '../filters/utils/urlSync';
import { SecurityDomainDto } from '@repo/shared/dtos/SecurityDomainDto';

const ANALYTICS_REDIRECT_KEY = 'analytics_filters';

export const checkAnalyticsSecurityDomain = (domain: SecurityDomainDto) => async () => {
  try {
    await checkSecurityDomain(domain)();
  } catch (error) {
    const currentUrl = window.location.href;
    if (redirectPreservation.shouldPreserve(currentUrl) && urlSync.shouldPreserveFilters()) {
      redirectPreservation.preserve(ANALYTICS_REDIRECT_KEY, currentUrl);
    }

    throw error;
  }
};
